/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from "react";
import { useHistory } from "react-router-dom";

import { useTextMessage } from '@fitinsur/hooks';
import { ButtonWithIcon, HasPermission } from "@fitinsur/components";

import * as S from './components/styles';

export function ProductNavigation({ permissions, match, ...props }) {
  const { getDescription } = useTextMessage();
  const history = useHistory();

  return (
    <HasPermission permission={permissions?.EDIT_ECONOMIC_INDEXERS || permissions?.READ_DOCUMENT_PARAMETERS}>
      <div style={{ display: "flex", flexDirection: "column", gap: "20px", marginBottom: "20px" }}>
        <S.Title>{getDescription("DOMAINS", 940, { withSkeleton: true, textFormat: 'uppercase' })}</S.Title>
        
        <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
          <HasPermission permission={permissions?.EDIT_ECONOMIC_INDEXERS}>
            <ButtonWithIcon
              width="140px"
              height="50px"
              onClick={() => {
                if (props.currentList === 'economic-indexers') return;
                history.push("/management/58/economic-indexers");
                props.setCurrentList("economic-indexers")
              }}
              icon={{ name: "indexes" }}
              title={getDescription("DOMAINS", 1121, { withSkeleton: true, textFormat: 'uppercase' })}
            />
          </HasPermission>

          <HasPermission permission={permissions?.READ_DOCUMENT_PARAMETERS}>
            <ButtonWithIcon
              width="140px"
              height="50px"
              onClick={() => {
                if (props.currentList === 'document-params') return;
                history.push("/management/58/document-params");
                props.setCurrentList("document-params")
              }}
              icon={{ name: "document-params" }}
              title={getDescription("DOMAINS", 1281, { withSkeleton: true, textFormat: 'uppercase' })}
            />
          </HasPermission>
        </div>
      </div>
    </HasPermission>
  );
}
